import { Box, Flex, Text ,useBreakpointValue} from '@chakra-ui/react';
import {DashBoardCard} from '../components/dashboard-card';
import { ROUTES } from '../routes';

import { FcShipped } from 'react-icons/fc'
import { MdSettings, MdNewReleases} from 'react-icons/md'
import { FaShippingFast} from 'react-icons/fa'
import { GrInProgress,GrAdd, GrSearch } from 'react-icons/gr'
import { TbTruckReturn } from 'react-icons/tb'
import { useEffect } from 'react';
import { isAdmin, isCaptin, isLoggedIn } from '../fetch/auth';
import { useNavigate } from 'react-router-dom';

export const Home = () => {
  const navigate = useNavigate();
const is_captin=isCaptin();
  useEffect(() => {

    if (!isLoggedIn()) {
      
      navigate(ROUTES.SIGN_UP);
    }


  }, [navigate]);


  const cards=[
    ...!is_captin?[
    {
        id:'طرد جديد',
        index:0,
        route:ROUTES.NEW_SHIPP,
        icon:GrAdd
    }]:[],
    {
        id:'موقف الطرد',
        index:1,
        route:ROUTES.VIEW_SHIPP,
        icon:GrSearch
    },
    ...!is_captin? [
    {
      id:'الجديدة',
      index:2,
      route:ROUTES.LIST_SHIPP('0'),
      icon:MdNewReleases
    }, 
    {
        id:'قيد التنفيذ',
        index:3,
        route:ROUTES.LIST_SHIPP('1'),
        icon:GrInProgress
    }]:[],
    {
        id:'مع الكابتن',
        index:4,
        route:ROUTES.LIST_SHIPP('2'),
        icon:FaShippingFast
    },
    {
      id:'مرتجع',
      index:5,
      route:ROUTES.LIST_SHIPP('3'),
      icon:TbTruckReturn
  },
    {
        id:'منتهي',
        index:6,
        route:ROUTES.LIST_SHIPP('4'),
        icon:FcShipped
    },
    ...(isAdmin()? [
    {
      id:'لوحة التحكم',
      index:5,
      route:ROUTES.ADMIN_CONTROL,
      icon:MdSettings
  }] : [])
];

  return (
 
    <Flex minH="calc(100vh - 60px)" direction={'column'} >
   <Flex 
      marginTop={'50px'}
      direction={'column'}
      justify='center'
      align='center'>
<Box padding={'10px'} cursor="pointer" onClick={()=>{navigate(ROUTES.LANDING)}}>
    <Text   
     as={'span'}
     position={'relative'}
     textAlign={'center'} 
        fontWeight={'bold'}
        fontSize={'3xl'}
        _after={{
          content: "''",
          width: 'full',
          height: useBreakpointValue({ base: '20%', md: '30%' }),
          position: 'absolute',
          bottom: 1,
          left: 0,
          bg: 'blue.400',
          zIndex: -1,
        }}>
      Pro Express
    </Text> 
    <Text      
    textAlign={'center'}      
        fontSize={'2xl'}
        fontWeight={'semibold'}
        color={'blue.500'}
     >
      Speed Of Delivery
    </Text> 
</Box>
    <Flex dir="rtl" 
     justify={'center'}
     align={'center'}
      flexWrap='wrap'
      flexDirection={'row'}
      marginTop={'20px'}
    >
 
      {cards.map((card,index) => (
        <DashBoardCard key={index} cardDetails={card} />
      ))}
      
    </Flex>
    </Flex>
  </Flex>
  )
}